import { APIClient, getToken } from '@nielsen-media/ui-toolkit-vue-api';
import { EventBus } from '@nielsen-media/ui-toolkit-vue';
import { installShadowApiTracking } from '@/helpers/shadowModeTracking';

const mavClient = new APIClient(`${process.env.VUE_APP_MAV_API_URL}`, getToken, EventBus);

mavClient.conn.defaults.headers.common['X-API-Key'] = process.env.VUE_APP_MAV_API_KEY;

installShadowApiTracking(mavClient.conn);

export default mavClient;
